import { Item } from "../types/item";

export const items: Item[] = [
    { id: 1, date: new Date(2023, 7, 1), category: 'salary', description: 'Salário', value: 6000.00 },
    { id: 2, date: new Date(2023, 7, 1), category: 'food', description: 'Almoço', value: 25.00 },
]